export type AgenticTaskMode = "auto" | "plan" | "discuss" | "analyze" | "draft";

export interface AgenticTaskModeOption {
  value: AgenticTaskMode;
  label: string;
  title: string;
  triggerText: string;
  triggerBorder: string;
  triggerBackground: string;
  triggerDot: string;
}

export const agenticTaskModeOptions: AgenticTaskModeOption[] = [
  {
    value: "plan",
    label: "Plan",
    title: "Stage the next steps",
    triggerText: "#efb06a",
    triggerBorder: "transparent",
    triggerBackground: "transparent",
    triggerDot: "#efb06a",
  },
  {
    value: "discuss",
    label: "Discuss",
    title: "Ask questions, surf the market",
    triggerText: "#f8f6ed",
    triggerBorder: "transparent",
    triggerBackground: "transparent",
    triggerDot: "#f8f6ed",
  },
  {
    value: "analyze",
    label: "Analyze",
    title: "Live trader tools, MCP connectors, internal data",
    triggerText: "#c79f4a",
    triggerBorder: "transparent",
    triggerBackground: "transparent",
    triggerDot: "#c79f4a",
  },
  {
    value: "draft",
    label: "Draft",
    title:
      "Draft documents with data, pictures, Streamdown/Shadcn-style charts, stored in File Room",
    triggerText: "#355e3b",
    triggerBorder: "transparent",
    triggerBackground: "transparent",
    triggerDot: "#355e3b",
  },
];

const legacyModes: Record<string, AgenticTaskMode> = {
  auto: "auto",
  plan: "plan",
  discuss: "discuss",
  analyze: "analyze",
  draft: "draft",
  research: "discuss",
  execute: "analyze",
  review: "draft",
};

export function normalizeAgenticTaskMode(value: unknown): AgenticTaskMode {
  if (typeof value !== "string") return "analyze";
  const normalized = legacyModes[value.trim().toLowerCase()];
  if (normalized === "auto") return "analyze";
  if (normalized) return normalized;
  return "analyze";
}
